




import Vue from "vue";

export default Vue.extend({
  name: "vc-bf-cache-reload",
  mounted() {
    window.onpageshow = (event: any) => {
      if (event.persisted) {
        window.location.reload();
      }
    };
  }
});
